import React, { Fragment } from "react";
import Select from "react-select";
import "./VariantForm.css";
import { Link } from 'react-router-dom';
import { isNumber, isFloat, required, length } from "../../../util/validators";

const colourStyles = {
  control: (styles) => ({ ...styles, backgroundColor: "white" }),
  theme: (styles) => ({ ...styles, borderRadius: "8px" }),
};

const LeadTime = [
{ value: "1", label: "1" },
{ value: "2", label: "2" },
{ value: "3", label: "3" },
{ value: "4", label: "4" },
{ value: "5", label: "5" },
{ value: "6", label: "6" },
{ value: "7", label: "7" },
];

class VariantForm extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      formIsValid: false,

      isActive: true,

      foreign_price_isActive: false,


      variantForm: {
        selectedWarranty: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required],
        },
        // selectedSize: {
        //   value: [],
        //   valid: false,
        //   errorMessage: "",
        //   touched: false,
        //   validators: [required],
        // },
        // selectedColor: {
        //   value: [],
        //   valid: false,
        //   errorMessage: "",
        //   touched: false,
        //   validators: [required],
        // },
        lead_time: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required],
        },


        order_limit: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required, isNumber],
        },
        marketable_stock: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required, isNumber],
        },
        reference_price: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required, isFloat],
        },
        price: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required, isFloat],
        },
        foreign_price: {
          value: "",
          valid: true,
          errorMessage: "",
          touched: false,
          validators: [isFloat],
        },


        package_length: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required, isFloat],
        },
        package_width: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required, isFloat],
        },
        package_height: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required, isFloat],
        },
        package_weight: {
          value: "",
          valid: false,
          errorMessage: "",
          touched: false,
          validators: [required, isFloat],
        },
      },

    };

    this.inputSelectChangeHandler = this.inputSelectChangeHandler.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangePrice = this.handleChangePrice.bind(this);
    this.inputChangeHandler = this.inputChangeHandler.bind(this);
    this.createVariation = this.createVariation.bind(this);
  }

  componentDidUpdate(previousProps, previousState) {
    if (previousProps.callAddVariant !== this.props.callAddVariant) {
      if (this.handleValidation()) {
        var postVariantData;
        if (this.props.product.dataTheme === 1) {
          postVariantData = {
            selectedWarranty: parseInt(this.state.variantForm["selectedWarranty"].value.value),
            selectedSize: parseInt(this.props.variant.sizeId),
            selectedColor: 0,
            selectedProduct: parseInt(this.props.product.id),
            lead_time: parseInt(this.state.variantForm["lead_time"].value.value),

            title:this.props.variant.title,
            isActive:this.state.isActive,
            foreign_price_isActive:this.state.foreign_price_isActive,

            dataTheme: this.props.product.dataTheme,
            order_limit: parseInt(this.state.variantForm["order_limit"].value),
            marketable_stock: parseInt(this.state.variantForm["marketable_stock"].value),
            reference_price: parseFloat(this.state.variantForm["reference_price"].value),
            price: parseFloat(this.state.variantForm["price"].value),
            foreign_price: parseFloat(this.state.variantForm["foreign_price"].value),
            package_length: parseInt(this.state.variantForm["package_length"].value),
            package_width: parseInt(this.state.variantForm["package_width"].value),
            package_height: parseInt(this.state.variantForm["package_height"].value),
            package_weight: parseInt(this.state.variantForm["package_weight"].value),
          };
        }else{               
          postVariantData = {
            selectedWarranty: parseInt(this.state.variantForm["selectedWarranty"].value.value),
            selectedSize: 0,
            selectedColor: parseInt(this.props.variant.colorId),
            selectedProduct: parseInt(this.props.product.id),
            lead_time: parseInt(this.state.variantForm["lead_time"].value.value),

            title:this.props.variant.title,
            isActive:this.state.isActive,
            foreign_price_isActive:this.state.foreign_price_isActive,

            dataTheme: this.props.product.dataTheme,
            order_limit: parseInt(this.state.variantForm["order_limit"].value),
            marketable_stock: parseInt(this.state.variantForm["marketable_stock"].value),
            reference_price: parseFloat(this.state.variantForm["reference_price"].value),
            price: parseFloat(this.state.variantForm["price"].value),
            foreign_price: parseFloat(this.state.variantForm["foreign_price"].value),
            package_length:0,
            package_width:0,
            package_height:0,
            package_weight:0,
          };      
        }

        this.createVariation(postVariantData);            
      }
    }
  }

  
  createVariation = (postVariantData) => {
    const graphqlQuery = {
      query: `
        mutation createNewVariant($selectedWarranty: Int!, $selectedSize: Int!, $selectedColor: Int!, $selectedProduct: Int!, $title: String!, $isActive: Boolean!, $dataTheme: Int!, $lead_time: Int!, $order_limit: Int!, $marketable_stock: Int!, $reference_price: Float!, $price: Float!, $foreign_price: Float, $foreign_price_isActive: Boolean!, $package_length: Float!, $package_width: Float!, $package_height: Float!, $package_weight: Float!) {
          createVariant(VariantInput: {selectedWarranty: $selectedWarranty, selectedSize: $selectedSize, selectedColor: $selectedColor, selectedProduct: $selectedProduct, title: $title, isActive: $isActive, dataTheme: $dataTheme, lead_time: $lead_time, order_limit: $order_limit, marketable_stock: $marketable_stock, reference_price: $reference_price, price: $price, foreign_price: $foreign_price, foreign_price_isActive: $foreign_price_isActive, package_length: $package_length, package_width: $package_width, package_height: $package_height, package_weight: $package_weight}) {
            id
            code
            title
            dataTheme
            lead_time
            order_limit
            marketable_stock
            reference_price
            price
            foreign_price
            foreign_price_isActive
            package_length
            package_width
            package_height
            package_weight
            isActive
            isDeleted
            productId
            sizeId
            colorId
            warrantyId
            color{
              title
              hexCode  
            }
            size{
              title
            }
            warranty{
              title
              period
            }
          }
        }
        `,
        variables: postVariantData,
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })

    .then((res) => {
      return res.json();
    })
    .then((resData) => {
      console.log(resData);
      if (resData.errors && resData.errors[0].status === 422) {
        throw new Error(
          "Validation failed. Make sure the email address isn't used yet!"
        );
      }
      if (resData.errors) {
        throw new Error("ورود کاربر ناموفق!");
      }

      var variant = {
        id: resData.data["createVariant"].id,
        code: resData.data["createVariant"].code,
        title: resData.data["createVariant"].title,
        dataTheme: resData.data["createVariant"].dataTheme,
        lead_time: resData.data["createVariant"].lead_time,
        order_limit: resData.data["createVariant"].order_limit,
        marketable_stock: resData.data["createVariant"].marketable_stock,
        reference_price: resData.data["createVariant"].reference_price,
        price: resData.data["createVariant"].price,
        foreign_price: resData.data["createVariant"].foreign_price,
        package_length: resData.data["createVariant"].package_length,
        package_width: resData.data["createVariant"].package_width,
        package_height: resData.data["createVariant"].package_height,
        package_weight: resData.data["createVariant"].package_weight,
        isActive: resData.data["createVariant"].isActive,
        foreign_price_isActive: resData.data["createVariant"].foreign_price_isActive,
        isDeleted: resData.data["createVariant"].isDeleted,
        productId: resData.data["createVariant"].productId,
        sizeId: resData.data["createVariant"].sizeId,
        colorId: resData.data["createVariant"].colorId,
        warrantyId: resData.data["createVariant"].warrantyId,
        color: resData.data["createVariant"].color,
        size: resData.data["createVariant"].size,
        warranty: resData.data["createVariant"].warranty,
      };

      // this.setState((prevState) => {
      //     let updatedTotalColors = prevState.totalColors;
      //     let updatedPosts = [...prevState.colors];
      //     if (postData.editingCode !== 0) {
      //       const postIndex = prevState.colors.findIndex(
      //         (p) => p.id == post.id
      //         );
      //       updatedPosts[postIndex] = post;
      //     } else {
      //       updatedTotalColors++;
      //       if (prevState.colors.length >= prevState.perPage) {
      //         updatedPosts.pop();
      //       }
      //       updatedPosts.unshift(post);
      //     }

          

      //     return {
      //       active: false,
      //       colors: updatedPosts,
      //       totalColors: updatedTotalColors
      //     };
        
      // });
      // });, {id: this.props.Identifier}
      
      this.props.createVariantSuccess({id: this.props.Identifier, variant: variant});
    })
    .catch((err) => {
      console.log(err);
      this.setState({
        error: err,
      });
    });
  

      //this.props.addProductHandler(postVariantData);
  };


  handleValidation() {
    if (this.state.formIsValid) {
      return true;
    }

    this.setState((prevState) => {
      let updatedForm = { ...prevState.variantForm };
      for (const inputName in prevState.variantForm) {
        let isValid = true;
        let errorMessage = "";
        if ( inputName === "selectedWarranty" || inputName === "lead_time" ) {
          for (const validator of prevState.variantForm[inputName].validators) {
            isValid = isValid && validator(prevState.variantForm[inputName].value.value).hasError;
            errorMessage = !isValid && errorMessage === "" ? validator(prevState.variantForm[inputName].value.value).errorMessage : errorMessage;
          }
        } else {
          if (this.props.product.dataTheme === 1) {
            for (const validator of prevState.variantForm[inputName].validators) {
              isValid = isValid && validator(prevState.variantForm[inputName].value).hasError;
              errorMessage = !isValid && errorMessage === "" ? validator(prevState.variantForm[inputName].value).errorMessage : errorMessage;
            }
          }else{
            if (inputName === "order_limit" || inputName === "marketable_stock" || inputName === "reference_price" || inputName === "price" || inputName === "foreign_price" ) {
              for (const validator of prevState.variantForm[inputName].validators) {
                isValid = isValid && validator(prevState.variantForm[inputName].value).hasError;
                errorMessage = !isValid && errorMessage === "" ? validator(prevState.variantForm[inputName].value).errorMessage : errorMessage;
              }
            }            
          }          
        }
        updatedForm = {
          ...updatedForm,
          [inputName]: {
            ...updatedForm[inputName],
            valid: isValid,
            errorMessage: errorMessage,
          },
        };
      }
      return {
        variantForm: updatedForm,
      };
    });
  }


  inputChangeHandler(event) {
    const val = event.target;
    this.setState((prevState) => {
      let isValid = true;
      let errorMessage = "";
      for (const validator of prevState.variantForm[val.id].validators) {
        isValid = isValid && validator(val.value).hasError;
        errorMessage = !isValid && errorMessage === "" ? validator(val.value).errorMessage : errorMessage;
      }
      const updatedForm = {
        ...prevState.variantForm,
        [val.id]: {
          ...prevState.variantForm[val.id],
          valid: isValid,
          value: val.value,
          errorMessage: errorMessage,
        },
      };

      let formIsValid = true;
      for (const inputName in updatedForm) {
        if (this.props.product.dataTheme === 1) {
          formIsValid = formIsValid && updatedForm[inputName].valid;
        }else{
          if (inputName === "order_limit" || inputName === "marketable_stock" || inputName === "reference_price" || inputName === "price" || inputName === "foreign_price" || inputName === "selectedWarranty" || inputName === "lead_time") {
            formIsValid = formIsValid && updatedForm[inputName].valid;
          }            
        }
      }

      return {
        variantForm: updatedForm,
        formIsValid: formIsValid,
      };
    });
  }

  inputSelectChangeHandler(event, selector) {
    this.setState((prevState) => {
      let isValid = true;
      let errorMessage = "";
      for (const validator of prevState.variantForm[selector.name]
        .validators) {
        isValid = isValid && validator(event.value.toString()).hasError;
        errorMessage = !isValid && errorMessage === "" ? validator(event.value.toString()).errorMessage : errorMessage;
      }
      const updatedForm = {
        ...prevState.variantForm,
        [selector.name]: {
          ...prevState.variantForm[selector.name],
          valid: isValid,
          value: event,
          errorMessage: errorMessage,
        },
      };
      
      let formIsValid = true;
      for (const inputName in updatedForm) {
        if (this.props.product.dataTheme === 1) {
          formIsValid = formIsValid && updatedForm[inputName].valid;
        }else{
          if (inputName === "order_limit" || inputName === "marketable_stock" || inputName === "reference_price" || inputName === "price" || inputName === "foreign_price" || inputName === "selectedWarranty" || inputName === "lead_time") {
            formIsValid = formIsValid && updatedForm[inputName].valid;
          }            
        }
      }

      return {
        variantForm: updatedForm,
        formIsValid: formIsValid,
      };
    });
  }

  inputBlurHandler = (input) => {
    this.setState((prevState) => {
      return {
        variantForm: {
          ...prevState.variantForm,
          [input]: {
            ...prevState.variantForm[input],
            touched: true,
          },
        },
      };
    });
  };

  handleChange(event) {
    if (event.target.id === "isActive") {
      this.setState({ isActive: event.target.checked });
    }
  }

  handleChangePrice(event) {
    if (event.target.id === "foreign_price_isActive") {
      this.setState({ foreign_price_isActive: event.target.checked });
    }
  }

  render() {
    return (
      <Fragment>
        <div id="variantsContainer" className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial relative">
            {/* <div className="c-content-loader">
                <div className="c-content-loader__logo"></div>
                <div className="c-content-loader__spinner"></div>
            </div> */}
            <div className="mn-variant-box js-new-variant-container" data-max_lead_time="2">
                <input type="hidden" className="js-variant-iterator" name="product_variants[variants][]" value="0"/>
                <input type="hidden" className="js-variant-attribute-id" name="product_variants[variant_0_attribute]" value="32573"/>
                <div className="mn-variant-box__main">
                    <button type="button" className="mn-ui-btn mn-ui-btn--clear-form mn-variant-box__clear-form mn-variant-box__clear-form--absolute" onClick={this.props.onRemoveVariantFormHandle.bind(this, {id: this.props.Identifier})}></button>
                    <div className="mn-grid__row mn-grid__row--gap-lg">
                      {this.props.product.dataTheme === 1 && (
                        <div className="mn-grid__col mn-grid__col--sm-2 mn-grid__col--flex-initial">
                            <label className="uk-form-label">اندازه کالا:</label>
                            <div className="field-wrapper">
                                <div className="uk-input uk-flex uk-flex-middle readonly"> <span className="js-variant-attribute-title">{this.props.variant.title}</span>
                                </div>
                            </div>
                        </div>
                      )}

                      {this.props.product.dataTheme === 2 && (
                        <div className="mn-grid__col mn-grid__col--sm-2 mn-grid__col--flex-initial">
                          <label className="uk-form-label">رنگ کالا:</label>
                          <div className="field-wrapper">
                            <div className="uk-input uk-flex uk-flex-middle readonly"> 
                              <span className="mn-variant-checkbox__color" style={{backgroundColor: "#"+this.props.variant.hexCode }}></span>
                              <span className="js-variant-attribute-title">{this.props.variant.title}</span>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className={["mn-grid__col mn-grid__col--flex-initial",
                          this.props.product.dataTheme !== 3 ? "mn-grid__col--sm-10":"", ].join(" ")}>
                          <label className="uk-form-label uk-flex uk-flex-between">گارانتی کالا: <span className="uk-form-label__required"></span>
                              {/* <Link href="#" className="search-link js-request-new-warranty">درخواست گارانتی جدید</Link> */}
                          </label>
                          <div className="field-wrapper ui-select ui-select__container">
                              <div className={["field-wrapper",
                                      this.state.variantForm["selectedWarranty"].errorMessage === "" ? "" : "has-error",
                                  ].join(" ")}>      
                                      <Select
                                          name="selectedWarranty"
                                          control="input"
                                          value={this.state.variantForm["selectedWarranty"].value}
                                          options={this.props.warranties.map(item => ({ value: item.id, label: item.title }))}
                                          styles={colourStyles}
                                          theme={colourStyles.theme}
                                          onChange={this.inputSelectChangeHandler}
                                          onBlur={this.inputBlurHandler.bind(this, "selectedWarranty")}
                                          value={this.state.variantForm["selectedWarranty"].value}
                                          valid={this.state.variantForm["selectedWarranty"].valid}
                                          touched={this.state.variantForm["selectedWarranty"].touched}
                                      /> 
                                                                      
                                  <div id={2} className="error error-msg">
                                      {this.state.variantForm["selectedWarranty"].errorMessage}
                                  </div>
                              </div>
                              <div></div>
                          </div>
                      </div>
                    </div>
                    <div className="mn-grid__row mn-grid__row--gap-lg">
                        {/* <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--flex-initial">
                            <label className="uk-form-label">کانال فروش: <span className="uk-form-label__required"></span>
                            </label>
                            <div className="field-wrapper field-wrapper--background uk-flex uk-flex-middle">
                                <label className="mn-ui-radio mn-ui-radio--gap-sm disabled">
                                    <input type="radio" className="mn-ui-radio__origin js-variant-site-digikala" name="product_variants[variant_0_site]" value="digikala" checked="" disabled=""/> <span className="mn-ui-radio__check mn-ui-radio__check--small"></span>
                                    <span className="mn-ui-radio__label">دیجی‌کالا</span>
                                </label>
                                <label className="mn-ui-radio mn-ui-radio--gap-sm disabled">
                                    <input type="radio" className="mn-ui-radio__origin js-variant-site-digistyle" name="product_variants[variant_0_site]" value="digistyle" disabled=""/> <span className="mn-ui-radio__check mn-ui-radio__check--small"></span>
                                    <span className="mn-ui-radio__label">دیجی‌استایل</span>
                                </label>
                                <label className="mn-ui-radio mn-ui-radio--gap-sm disabled">
                                    <input type="radio" className="mn-ui-radio__origin js-variant-site-both" name="product_variants[variant_0_site]" value="both" disabled=""/> <span className="mn-ui-radio__check mn-ui-radio__check--small"></span>
                                    <span className="mn-ui-radio__label">دیجی‌کالا و دیجی‌استایل</span>
                                </label>
                            </div>
                        </div>
                        <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--flex-initial">
                            <label className="uk-form-label">ارسال توسط: <span className="uk-form-label__required"></span>
                            </label>
                            <div className="field-wrapper field-wrapper--background uk-flex uk-flex-middle js-checkbox-group-container">
                                <label className="mn-ui-checkbox mn-ui-checkbox--gap-sm disabled">
                                    <input type="checkbox" className="mn-ui-checkbox__origin js-variant-shipping-type-digikala js-checkbox-group" name="product_variants[variant_0_shipping_type_digikala]" value="1" checked=""/> <span className="mn-ui-checkbox__check mn-ui-checkbox__check--small"></span>
                                    <span className="mn-ui-checkbox__label">دیجی‌کالا</span>
                                </label>
                                <label className="mn-ui-checkbox mn-ui-checkbox--gap-sm disabled">
                                    <input type="checkbox" className="mn-ui-checkbox__origin js-variant-shipping-type-seller js-checkbox-group" name=""/> <span className="mn-ui-checkbox__check mn-ui-checkbox__check--small"></span>
                                    <span className="mn-ui-checkbox__label">فروشنده</span>
                                </label>
                            </div>
                        </div> */}
                        <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--flex-initial">
                            <label htmlFor="isActive" className="uk-form-label">
                            فعال / غیرفعال: <span className="uk-form-label__required"></span>
                            </label>
                            <div className="mn-field-wrapper field-wrapper--background">
                            <label className="mn-ui-checkbox--container">
                                <input
                                type="checkbox"
                                className="mn-ui-checkbox__checkbox"
                                name="isActive"
                                id="isActive"
                                value="1"
                                onChange={this.handleChange}
                                checked={this.state.isActive}
                                />
                                <span className="mn-ui-checkbox__checkmark"></span>
                                <span className="mn-ui-checkbox__label">
                                فعال / غیرفعال
                                </span>
                            </label>
                            </div>
                        </div>
                    

                    {/* //////////////////////////////////////////////////////////////////////////////////////////////// */}
                  
                        <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--flex-initial">
                            <label htmlFor="foreign_price_isActive" className="uk-form-label">
                            قیمت بر مبنای درهم محاسبه شود: <span className="uk-form-label__required"></span>
                            </label>
                            <div className="mn-field-wrapper field-wrapper--background">
                            <label className="mn-ui-checkbox--container">
                                <input
                                type="checkbox"
                                className="mn-ui-checkbox__checkbox"
                                name="foreign_price_isActive"
                                id="foreign_price_isActive"
                                value="1"
                                onChange={this.handleChangePrice}
                                checked={this.state.foreign_price_isActive}
                                />
                                <span className="mn-ui-checkbox__checkmark"></span>
                                <span className="mn-ui-checkbox__label">
                                فعال / غیرفعال
                                </span>
                            </label>
                            </div>
                        </div>
                

                        <div className="mn-grid__col mn-ui--mt-20 mn-grid__col--sm-3 mn-grid__col--flex-initial">
                            <label className="uk-form-label">قیمت فروش (درهم): 
                            </label>
                            <div
                                className={[
                                    "field-wrapper",
                                    this.state.variantForm["foreign_price"].errorMessage === "" ? "" : "has-error",
                                ].join(" ")}
                                >
                                <input
                                    id="foreign_price"
                                    type="text"
                                    placeholder=""
                                    className="mn-content-input__origin"
                                    value={this.state.variantForm["foreign_price"].value}
                                    name="product[title_en]"
                                    onChange={this.inputChangeHandler}
                                    required=""
                                />
                                <div id={2} className="error error-msg">
                                    {this.state.variantForm["foreign_price"].errorMessage}
                                </div>
                            </div>
                            <div></div>
                        </div>
                      </div>
                    {/* //////////////////////////////////////////////////////////////////////////////////////////////// */}



                    <div className="mn-grid__row mn-grid__row--gap-lg">
                        <div className="mn-grid__col mn-ui--mt-20 mn-grid__col--sm-2 mn-grid__col--flex-initial">
                            <label className="uk-form-label">بازه زمانی ارسال (روز): <span className="uk-form-label__required"></span>
                            </label>
                            <div className="field-wrapper ui-select ui-select__container">
                                <div className={["field-wrapper",
                                        this.state.variantForm["lead_time"].errorMessage === "" ? "" : "has-error",
                                    ].join(" ")}>      
                                        <Select
                                            name="lead_time"
                                            control="input"
                                            value={this.state.variantForm["lead_time"].value}
                                            options={LeadTime}
                                            styles={colourStyles}
                                            theme={colourStyles.theme}
                                            onChange={this.inputSelectChangeHandler}
                                            onBlur={this.inputBlurHandler.bind(this, "lead_time")}
                                            value={this.state.variantForm["lead_time"].value}
                                            valid={this.state.variantForm["lead_time"].valid}
                                            touched={this.state.variantForm["lead_time"].touched}
                                        />
                                                                        
                                    <div id={2} className="error error-msg">
                                        {this.state.variantForm["lead_time"].errorMessage}
                                    </div>
                                </div>
                                <div></div>
                            </div>
                        </div>
                        <div className="mn-grid__col mn-ui--mt-20 mn-grid__col--sm-2 mn-grid__col--flex-initial">
                            <label htmlFor="" className="uk-form-label">حداکثر سفارش در سبد (عدد): <span className="uk-form-label__required"></span>
                            </label>
                            <div
                                className={[
                                    "field-wrapper",
                                    this.state.variantForm["order_limit"].errorMessage === "" ? "" : "has-error",
                                ].join(" ")}
                                >
                                <input
                                    id="order_limit"
                                    type="text"
                                    placeholder=""
                                    className="mn-content-input__origin"
                                    value={this.state.variantForm["order_limit"].value}
                                    name="product[title_en]"
                                    onChange={this.inputChangeHandler}
                                    required=""
                                />
                                <div id={2} className="error error-msg">
                                    {this.state.variantForm["order_limit"].errorMessage}
                                </div>
                            </div>
                            <div></div>
                        </div>
                        <div className="mn-grid__col mn-ui--mt-20 mn-grid__col--sm-2 mn-grid__col--flex-initial">
                            <label className="uk-form-label">موجودی نزد شما (عدد): <span className="uk-form-label__required"></span>
                            </label>
                            <div
                                className={[
                                    "field-wrapper",
                                    this.state.variantForm["marketable_stock"].errorMessage === "" ? "" : "has-error",
                                ].join(" ")}
                                >
                                <input
                                    id="marketable_stock"
                                    type="text"
                                    placeholder=""
                                    className="mn-content-input__origin"
                                    value={this.state.variantForm["marketable_stock"].value}
                                    name="product[title_en]"
                                    onChange={this.inputChangeHandler}
                                    required=""
                                />
                                <div id={2} className="error error-msg">
                                    {this.state.variantForm["marketable_stock"].errorMessage}
                                </div>
                            </div>
                            <div></div>
                        </div>
                        {/* <div className="mn-grid__col mn-ui--mt-20 mn-grid__col--sm-2 mn-grid__col--flex-initial">
                            <label className="uk-form-label">کد محصول فروشنده:</label>
                            <div className="field-wrapper">
                                <input type="text" className="uk-input js-variant-supplier-code" name="product_variants[variant_0_supplier_code]" value=""/>
                            </div>
                        </div> */}
                        <div className="mn-grid__col mn-ui--mt-20 mn-grid__col--sm-3 mn-grid__col--flex-initial">
                            <label className="uk-form-label">قیمت مرجع (ریال):</label>
                            {/* <div className="field-wrapper">
                                <input type="text" className="uk-input disabled" value="911166" disabled=""/>
                            </div> */}
                            <div
                                className={[
                                    "field-wrapper",
                                    this.state.variantForm["reference_price"].errorMessage === "" ? "" : "has-error",
                                ].join(" ")}
                                >
                                <input
                                    id="reference_price"
                                    type="text"
                                    placeholder=""
                                    className="mn-content-input__origin"
                                    value={this.state.variantForm["reference_price"].value}
                                    name="product[title_en]"
                                    onChange={this.inputChangeHandler}
                                    required=""
                                />
                                <div id={2} className="error error-msg">
                                    {this.state.variantForm["reference_price"].errorMessage}
                                </div>
                            </div>
                            <div></div>
                        </div>
                        <div className="mn-grid__col js-gold-price-field uk-hidden mn-ui--mt-20 mn-grid__col--sm-2 mn-grid__col--flex-initial">
                            <label className="uk-form-label">قیمت روز طلا (ریال):</label>
                            <div className="field-wrapper"></div>
                        </div>
                        <div className="mn-grid__col js-gold-price-field uk-hidden mn-ui--mt-20 mn-grid__col--sm-2 mn-grid__col--flex-initial">
                            <label className="uk-form-label">اجرت ساخت طلا (درصد): <span className="uk-form-label__required"></span>
                            </label>
                            <div className="field-wrapper"> <span className="o-text-color-n-400 o-font-size-10">حداکثر مقدار :‌</span>
                                <span className="js-input-max-value-hint o-font-size-10 o-text-color-n-400"></span>
                            </div>
                        </div>
                        <div className="mn-grid__col js-gold-price-field uk-hidden mn-ui--mt-20 mn-grid__col--sm-2 mn-grid__col--flex-initial">
                            <label className="uk-form-label">هزینه، اجرت و سود اجزای غیر طلا: <span className="uk-form-label__required"></span>
                            </label>
                            <div className="field-wrapper"> <span className="o-text-color-n-400 o-font-size-10">مقدار به (ریال)‌</span>
                            </div>
                        </div>
                        <div className="mn-grid__col js-gold-price-field uk-hidden mn-ui--mt-20 mn-grid__col--sm-2 mn-grid__col--flex-initial">
                            <label className="uk-form-label">اجرت اجزای غیر طلا (ریال): <span className="uk-form-label__required"></span>
                            </label>
                            <div className="field-wrapper"></div>
                        </div>
                        <div className="mn-grid__col js-gold-price-field uk-hidden mn-ui--mt-20 mn-grid__col--sm-2 mn-grid__col--flex-initial">
                            <label className="uk-form-label">درصد سود طلای خام: <span className="uk-form-label__required"></span>
                            </label>
                            <div className="field-wrapper"> <span className="o-text-color-n-400 o-font-size-10">حداکثر مقدار :‌</span>
                                <span className="js-input-max-value-hint o-font-size-10 o-text-color-n-400"></span>
                            </div>
                        </div>
                        <div className="mn-grid__col js-gold-price-field uk-hidden mn-ui--mt-20 mn-grid__col--sm-2 mn-grid__col--flex-initial">
                            <label className="uk-form-label">مالیات (‌درصد):</label>
                            <div className="field-wrapper"></div>
                        </div>
                        <div className="mn-grid__col mn-ui--mt-20 mn-grid__col--sm-3 mn-grid__col--flex-initial">
                            <label className="uk-form-label">قیمت فروش (ریال): <span className="uk-form-label__required"></span>
                            </label>
                            <div
                                className={[
                                    "field-wrapper",
                                    this.state.variantForm["price"].errorMessage === "" ? "" : "has-error",
                                ].join(" ")}
                                >
                                <input
                                    id="price"
                                    type="text"
                                    placeholder=""
                                    className="mn-content-input__origin"
                                    value={this.state.variantForm["price"].value}
                                    name="product[title_en]"
                                    onChange={this.inputChangeHandler}
                                    required=""
                                />
                                <div id={2} className="error error-msg">
                                    {this.state.variantForm["price"].errorMessage}
                                </div>
                            </div>
                            <div></div>
                        </div>
                    </div>
                    {this.props.product.dataTheme === 1 && (
                    <div className="mn-grid__row mn-grid__row--gap-lg js-product-package-dimension">
                        <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--lg-8 ">
                            <div className="mn-grid__row mn-grid__row--gap-lg mn-grid__row--nowrap-sm">
                                <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--lg-6">
                                    <label for="" className="uk-form-label">ابعاد بسته‌بندی (سانتیمتر): <span className="uk-form-label__required"></span>
                                    </label>
                                    <div className="mn-grid__row mn-grid__row--gap-small mn-grid__row--nowrap-sm">
                                        <div className=" mn-grid__col mn-grid__col--gap-small mn-grid__col--flex-initial">
                                            <div
                                                className={[
                                                    "field-wrapper",
                                                    this.state.variantForm["package_length"].errorMessage === "" ? "" : "has-error",
                                                ].join(" ")}
                                                >
                                                <label className="mn-content-input">
                                                    {" "}
                                                    <span className="mn-content-input__text mn-content-input__text--overlay">
                                                    طول
                                                    </span>
                                                    <input
                                                    id="package_length"
                                                    type="text"
                                                    placeholder=""
                                                    className="mn-content-input__origin mn-content-input__origin--overlay"
                                                    value={this.state.variantForm["package_length"].value}
                                                    onChange={this.inputChangeHandler}
                                                    name="product[package_length]"
                                                    />
                                                </label>
                                                <div id={2} className="error error-msg">
                                                    {
                                                    this.state.variantForm["package_length"]
                                                        .errorMessage
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className=" mn-grid__col mn-grid__col--gap-small mn-grid__col--flex-initial mn-grid__col--xs-gap">
                                            <div
                                                className={[
                                                    "field-wrapper",
                                                    this.state.variantForm["package_width"].errorMessage === "" ? "" : "has-error",
                                                ].join(" ")}
                                                >
                                                <label className="mn-content-input">
                                                    {" "}
                                                    <span className="mn-content-input__text mn-content-input__text--overlay">
                                                    عرض
                                                    </span>
                                                    <input
                                                    id="package_width"
                                                    type="text"
                                                    placeholder=""
                                                    className="mn-content-input__origin mn-content-input__origin--overlay"
                                                    value={this.state.variantForm["package_width"].value}
                                                    onChange={this.inputChangeHandler}
                                                    name="product[package_width]"
                                                    />
                                                </label>
                                                <div id={2} className="error error-msg">
                                                    {
                                                    this.state.variantForm["package_width"]
                                                        .errorMessage
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className=" mn-grid__col mn-grid__col--gap-small mn-grid__col--flex-initial mn-grid__col--xs-gap">
                                            <div
                                                className={[
                                                    "field-wrapper",
                                                    this.state.variantForm["package_height"].errorMessage === "" ? "" : "has-error",
                                                ].join(" ")}
                                                >
                                                <label className="mn-content-input">
                                                    {" "}
                                                    <span className="mn-content-input__text mn-content-input__text--overlay">
                                                    ارتفاع
                                                    </span>
                                                    <input
                                                    id="package_height"
                                                    type="text"
                                                    placeholder=""
                                                    className="mn-content-input__origin mn-content-input__origin--overlay"
                                                    value={this.state.variantForm["package_height"].value}
                                                    onChange={this.inputChangeHandler}
                                                    name="product[package_height]"
                                                    />
                                                </label>
                                                <div id={2} className="error error-msg">
                                                    {
                                                    this.state.variantForm["package_height"]
                                                        .errorMessage
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--lg-6 mn-grid__col--xs-gap">
                                    <label for="" className="uk-form-label">وزن بسته بندی (گرم): <span className="uk-form-label__required"></span>
                                    </label>
                                    <div
                                        className={[
                                            "field-wrapper",
                                            this.state.variantForm["package_weight"].errorMessage === "" ? "" : "has-error",
                                        ].join(" ")}
                                        >
                                        <label className="mn-content-input">
                                            {" "}
                                            <span className="mn-content-input__text mn-content-input__text--overlay">
                                            وزن
                                            </span>
                                            <input
                                            id="package_weight"
                                            type="text"
                                            placeholder=""
                                            className="mn-content-input__origin mn-content-input__origin--overlay"
                                            value={this.state.variantForm["package_weight"].value}
                                            onChange={this.inputChangeHandler}
                                            name="product[package_weight]"
                                            />
                                        </label>
                                        <div id={2} className="error error-msg">
                                            {
                                            this.state.variantForm["package_weight"]
                                                .errorMessage
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    )}
                </div>
            </div>
        </div>
      </Fragment>
    );
  }
}

export default VariantForm;

  